<script lang="ts">
	import DecisionToolMarks from './DecisionToolMarks.svelte';
	import DecisionToolTotalScore from './DecisionToolTotalScore.svelte';
	import DecisionToolDetails from './DecisionToolDetails.svelte';
	import type { DecisionToolMarks as DecisionToolMarksType } from '$lib/types/props';

	export let scores: DecisionToolMarksType[];
	export let totalScore: string;
</script>

<div class="space-y-4">
	<DecisionToolMarks />
	<DecisionToolTotalScore />
	<DecisionToolTotalScore {totalScore} />
	<DecisionToolDetails {scores} />
</div>
